<script setup lang="ts">
/**
 * A text input with a filtered listbox: the user TYPES to narrow a list, then picks from it
 * (MAR-948). Use it where `ui/dropdown-menu` would swallow the typing (a menu does typeahead) and
 * `ui/popover` would take focus away from the input.
 *
 * Compose it as `Combobox > ComboboxAnchor > ComboboxInput` plus `ComboboxList > ComboboxItem`.
 * For an ASYNC or custom option source, pass `ignore-filter`, bind the input's `v-model` to your
 * search term and render only the options you computed from it — reka's built-in filter matches an
 * option's text only, and cannot see data that has not arrived yet.
 */
import type { ComboboxRootEmits, ComboboxRootProps } from "reka-ui"
import { ComboboxRoot, useForwardPropsEmits } from "reka-ui"

const props = defineProps<ComboboxRootProps>()
const emits = defineEmits<ComboboxRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <ComboboxRoot v-bind="forwarded">
    <slot />
  </ComboboxRoot>
</template>
